import { render, staticRenderFns } from "./HeaderOnbordading.vue?vue&type=template&id=c82cbad0&scoped=true"
import script from "./HeaderOnbordading.vue?vue&type=script&lang=ts"
export * from "./HeaderOnbordading.vue?vue&type=script&lang=ts"
import style0 from "./HeaderOnbordading.vue?vue&type=style&index=0&id=c82cbad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82cbad0",
  null
  
)

export default component.exports